import { TrendingUp } from 'lucide-react';
import { WHY_STATS, REACH_STATS } from '../data/content';
import SectionHead from './SectionHead';
import { Reveal, Stagger, Item } from '../lib/motion';

export function WhySection() {
  return (
    <section id="warum" data-testid="why-section" className="chapter">
      <div className="wrap">
        <SectionHead
          n="01"
          eyebrow="Warum im Markt werben"
          title="Radio erreicht alle. Wir erreichen die, die gerade kaufen."
          testid="why-headline"
          lead="Klassische Medien streuen breit – auch zu Menschen, die nie Ihre Kunden werden. Unsere Bildschirme erreichen ausschließlich Menschen, die in diesem Moment einkaufen. Drei Gründe, warum das wirkt."
        />

        <div className="mt-20 divide-y divide-[#282C37] border-y border-[#282C37]" data-testid="why-list">
          {WHY_STATS.map((s, i) => (
            <Reveal key={s.value} as="article" delay={i * 0.06} className="grid gap-4 py-10 lg:grid-cols-12 lg:gap-10" data-testid={`why-stat-${i}`}>
              <div className="lg:col-span-3">
                <p className="font-mono-num text-5xl font-bold tracking-tighter text-[#FF6B00] sm:text-6xl">{s.value}</p>
              </div>
              <div className="lg:col-span-6">
                <h3 className="font-display text-xl font-bold sm:text-2xl">{s.title}</h3>
                <p className="t-body mt-3 max-w-[58ch]">{s.text}</p>
              </div>
              <div className="lg:col-span-3 lg:text-right">
                {s.source && <p className="t-muted font-mono-num !text-xs uppercase tracking-wider">Quelle: {s.source}</p>}
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-24 grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <p className="eyebrow">Reichweite</p>
            <h3 className="mt-4 font-display text-2xl font-extrabold tracking-tight sm:text-3xl" data-testid="reach-headline">
              Zahlen, die Sie nachrechnen können.
            </h3>
            <p className="t-body mt-5">
              Grundlage ist die Zahl der Einkäufe an unseren Kassen – die Ist-Zahl des Marktes. Daraus ergibt sich, wie viele Menschen Ihren Spot sehen.
            </p>
            <p className="t-muted mt-5 border-l-2 border-[#FF6B00] pl-4" data-testid="reach-model-note">
              Modellrechnung: 1,4 Personen je Einkauf und rund 10 Bildschirm-Passagen je Besuch.
            </p>
          </Reveal>
          <Stagger className="grid content-start gap-px overflow-hidden rounded-2xl border border-[#282C37] bg-[#282C37] sm:grid-cols-2 lg:col-span-8">
            {REACH_STATS.map((s, i) => (
              <Item key={s.label} className="bg-[#16181D] p-8" data-testid={`reach-stat-${i}`}>
                <p className="font-mono-num text-4xl font-bold tracking-tighter text-white sm:text-5xl">{s.value}</p>
                <p className="t-body mt-3 max-w-[26ch]">{s.label}</p>
              </Item>
            ))}
          </Stagger>
        </div>

        <Reveal className="mt-12 flex items-start gap-4 rounded-2xl border border-[#FF6B00]/30 bg-[#FF6B00]/[0.06] p-6 sm:p-8" data-testid="why-market-note">
          <TrendingUp className="mt-1 h-5 w-5 shrink-0 text-[#FF6B00]" />
          <p className="t-body max-w-[70ch]">
            Der Markt für Bildschirmwerbung außer Haus ist 2025 in Deutschland um 26 Prozent gewachsen. Werbebudgets wandern dorthin,
            wo Reichweite nah am Kauf liegt. <span className="text-[#7D8391]">Quelle: Nielsen Werbetrend 2025, IDOOH</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
